export default "__VITE_ASSET__Cuo3jXI___"